if (!customElements.get('edc-search-overlay')) {
  customElements.define('edc-search-overlay', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.header = this.closest('.edc-header');
      this.trigger = this.header.querySelector('[data-search-open]');
      this.searchLabel = this.trigger.getAttribute('aria-label');
      this.finder = this.querySelector('edc-product-finder');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.addEventListener('click', () => this.dialog.open ? this.close() : this.open(), options);
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        this.cancelEntrance();
        this.finder.dropdowns?.forEach((dropdown) => dropdown.close());
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.setAttribute('aria-label', this.searchLabel);
        this.restorePage();
        this.trigger.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        const expanded = this.finder.dropdowns?.find((dropdown) => !dropdown.list.hidden);
        if (expanded) expanded.close();
        else this.close();
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientY < bounds.top || event.clientY > bounds.bottom ||
            event.clientX < bounds.left || event.clientX > bounds.right) this.close();
      }, options);
      window.addEventListener('resize', () => this.position(), options);
      const url = new URL(window.location.href);
      if (url.searchParams.get('finder') === 'open') {
        url.searchParams.delete('finder');
        history.replaceState(history.state, '', url);
        this.open();
      }
    }

    position() {
      const top = Math.max(0, this.header.getBoundingClientRect().bottom);
      this.dialog.style.setProperty('--edc-search-top', `${top}px`);
    }

    restorePage() {
      const root = document.documentElement;
      root.style.overflow = this.previousOverflow;
      root.style.scrollbarGutter = this.previousScrollbarGutter;
      window.scrollTo({ left: this.scrollPosition.x, top: this.scrollPosition.y, behavior: 'instant' });
    }

    cancelEntrance() {
      this.entranceAnimations?.forEach((animation) => animation.cancel());
      this.entranceAnimations = [];
    }

    animateEntrance() {
      this.cancelEntrance();
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const easing = 'cubic-bezier(0.2, 0.7, 0.3, 1)';
      const panelDuration = 320;
      const animate = (element, frames, timing) => {
        const animation = element.animate(frames, timing);
        this.entranceAnimations.push(animation);
        animation.onfinish = () => animation.cancel();
      };
      animate(this.dialog, [
        { opacity: 0, transform: 'translateY(-16px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ], { duration: panelDuration, easing });
      const items = this.querySelectorAll(
        '.edc-home__section-copy, .edc-home-product-finder__field, .edc-home-product-finder__action'
      );
      items.forEach((item, index) => animate(item, [
        { opacity: 0, transform: 'translateX(-10px)' },
        { opacity: 1, transform: 'translateX(0)' },
      ], { duration: 280, delay: panelDuration + index * 80, easing, fill: 'both' }));
    }

    open() {
      if (this.dialog.open) return;
      const menu = this.header.querySelector('.edc-header__mobile');
      if (menu?.dataset.expanded === 'true') menu.querySelector('summary').click();
      this.position();
      const root = document.documentElement;
      this.scrollPosition = { x: window.scrollX, y: window.scrollY };
      this.previousOverflow = root.style.overflow;
      this.previousScrollbarGutter = root.style.scrollbarGutter;
      root.style.scrollbarGutter = 'stable';
      root.style.overflow = 'hidden';
      this.dialog.showModal();
      window.scrollTo({ left: this.scrollPosition.x, top: this.scrollPosition.y, behavior: 'instant' });
      this.trigger.setAttribute('aria-expanded', 'true');
      this.trigger.setAttribute('aria-label', 'Close search');
      this.finder.ensureProducts();
      this.animateEntrance();
    }

    close() {
      this.cancelEntrance();
      if (this.dialog.open) this.dialog.close();
    }

    disconnectedCallback() {
      this.cancelEntrance();
      if (this.dialog.open) {
        this.dialog.close();
        this.restorePage();
      }
      this.controller.abort();
    }
  });
}
